export const DATA_BASE = "data/generated/";

export const STATIC_BACKGROUNDS = [
  "Soldado",
  "Eremita",
  "Nobre",
  "Criminoso",
  "Sábio",
  "Artesão da Guilda",
  "Forasteiro",
  "Marinheiro",
  "Herói do Povo",
  "Órfão das Ruas",
];

export const ALL_STEP_IDS = [
  "identidade",
  "raca",
  "background",
  "nivel",
  "classe",
  "subclasse",
  "atributos",
  "resumo",
];

export const STEP_LABELS = {
  identidade: "Identidade",
  raca: "Raça",
  background: "Background",
  nivel: "Nível Inicial",
  classe: "Classe",
  subclasse: "Subclasse",
  atributos: "Atributos",
  resumo: "Resumo",
};

export const STEP_VISUALS = {
  identidade: {
    image: "assets/images/cards/step-identity.svg",
    accent: "hsl(197 72% 62%)",
    soft: "hsla(197 72% 60% / 0.22)",
    glow: "hsla(197 90% 65% / 0.32)",
    hint: "Nome e história",
  },
  raca: {
    image: "assets/images/cards/race-mountains.svg",
    accent: "hsl(33 72% 62%)",
    soft: "hsla(33 72% 60% / 0.22)",
    glow: "hsla(33 90% 65% / 0.32)",
    hint: "Linhagem",
  },
  background: {
    image: "assets/images/cards/step-identity.svg",
    accent: "hsl(142 48% 56%)",
    soft: "hsla(142 48% 56% / 0.22)",
    glow: "hsla(142 70% 68% / 0.34)",
    hint: "História prévia",
  },
  nivel: {
    image: "assets/images/cards/level-3.svg",
    accent: "hsl(46 72% 62%)",
    soft: "hsla(46 72% 60% / 0.22)",
    glow: "hsla(46 90% 65% / 0.32)",
    hint: "Ponto de início",
  },
  classe: {
    image: "assets/images/cards/class-martial.svg",
    accent: "hsl(18 68% 60%)",
    soft: "hsla(18 68% 60% / 0.22)",
    glow: "hsla(18 90% 66% / 0.34)",
    hint: "Função de combate",
  },
  subclasse: {
    image: "assets/images/cards/class-time.svg",
    accent: "hsl(281 62% 64%)",
    soft: "hsla(281 62% 64% / 0.22)",
    glow: "hsla(281 88% 72% / 0.34)",
    hint: "Especialização",
  },
  atributos: {
    image: "assets/images/cards/step-attributes.svg",
    accent: "hsl(208 72% 62%)",
    soft: "hsla(208 72% 62% / 0.22)",
    glow: "hsla(208 90% 70% / 0.34)",
    hint: "Valores base",
  },
  resumo: {
    image: "assets/images/cards/step-summary.svg",
    accent: "hsl(44 72% 62%)",
    soft: "hsla(44 72% 62% / 0.22)",
    glow: "hsla(44 90% 70% / 0.34)",
    hint: "Ficha final",
  },
};

export const STANDARD_ARRAY = [15, 14, 13, 12, 10, 8];

export const POINT_BUY_COSTS = { 8: 0, 9: 1, 10: 2, 11: 3, 12: 4, 13: 5, 14: 7, 15: 9 };
export const POINT_BUY_BUDGET = 27;
export const POINT_BUY_MIN = 8;
export const POINT_BUY_MAX = 15;

export const ABILITY_KEYS = ["str", "dex", "con", "int", "wis", "cha"];

export const ABILITY_NAMES = {
  str: "Força",
  dex: "Destreza",
  con: "Constituição",
  int: "Inteligência",
  wis: "Sabedoria",
  cha: "Carisma",
};

export const EXTRA_FIELD_LABELS = {
  subclass: "Subclasse",
  feat1: "Feat #1",
  feat2: "Feat #2",
  asi: "Ability Score Improvement",
};

export const ALL_SKILLS = [
  "Acrobatics", "Animal Handling", "Arcana", "Athletics", "Deception",
  "History", "Insight", "Intimidation", "Investigation", "Medicine",
  "Nature", "Perception", "Performance", "Persuasion", "Religion",
  "Sleight of Hand", "Stealth", "Survival",
];

export const ALL_TOOLS = [
  "Alchemist's Supplies", "Brewer's Supplies", "Calligrapher's Supplies",
  "Carpenter's Tools", "Cartographer's Tools", "Cobbler's Tools",
  "Cook's Utensils", "Disguise Kit", "Forgery Kit", "Gaming Set (any)",
  "Glassblower's Tools", "Herbalism Kit", "Jeweler's Tools",
  "Leatherworker's Tools", "Mason's Tools", "Musical Instrument (any)",
  "Navigator's Tools", "Painter's Supplies", "Poisoner's Kit",
  "Potter's Tools", "Smith's Tools", "Thieves' Tools", "Tinker's Tools",
  "Weaver's Tools", "Woodcarver's Tools",
];

export const INITIAL_ATTRIBUTES = {
  str: 10,
  dex: 10,
  con: 10,
  int: 10,
  wis: 10,
  cha: 10,
};

export const INITIAL_CREATOR_STATE = {
  currentStepId: "identidade",
  name: "",
  surname: "",
  profileImageOriginal: "",
  profileImageCropped: "",
  profileImageName: "",
  profileCropX: 50,
  profileCropY: 50,
  profileCropZoom: 1,
  background: "",
  backgroundFeat: "",
  backgroundStats: { str: 0, dex: 0, con: 0, int: 0, wis: 0, cha: 0 },
  backgroundStatMode: null,
  race: null,
  origin: null,
  charClass: null,
  subclassData: null,
  startingPoint: null,
  startingPointData: null,
  attributes: { ...INITIAL_ATTRIBUTES },
  attrMode: null,
  attrConfirmed: false,
  rolledSets: null,
  rollAssignments: { str: null, dex: null, con: null, int: null, wis: null, cha: null },
  standardAssignments: { str: null, dex: null, con: null, int: null, wis: null, cha: null },
  pointBuyValues: { str: 8, dex: 8, con: 8, int: 8, wis: 8, cha: 8 },
  hpMethodLocked: null,
  hpConfirmed: false,
  hpRolledValues: null,
  subclass: "",
  feat1: "",
  feat2: "",
  asi: "",
  biography: "",
  tashaAbilityOverride: { str: 0, dex: 0, con: 0, int: 0, wis: 0, cha: 0 },
  humanRaceChoice: { skill: "", feat: "" },
  customLineage: null,
  customBackground: null,
};

export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function mod(score) {
  return Math.floor((score - 10) / 2);
}

export function modStr(score) {
  const modifier = mod(score);
  return modifier >= 0 ? `+${modifier}` : `${modifier}`;
}

export function normalizeTextValue(value) {
  return typeof value === "string" ? value.trim() : "";
}

export function normalizeAttributeValue(value) {
  const parsed = Number.parseInt(value, 10);
  return clamp(Number.isNaN(parsed) ? 10 : parsed, 1, 20);
}

export function roll4d6(randomFn = Math.random) {
  const dice = Array.from({ length: 4 }, () => Math.floor(randomFn() * 6) + 1);
  dice.sort((left, right) => left - right);
  return dice[1] + dice[2] + dice[3];
}

export function buildRolledAttributes(randomFn = Math.random) {
  return ABILITY_KEYS.reduce((attributes, key) => {
    attributes[key] = roll4d6(randomFn);
    return attributes;
  }, {});
}

export function buildStandardAttributes() {
  return ABILITY_KEYS.reduce((attributes, key, index) => {
    attributes[key] = STANDARD_ARRAY[index];
    return attributes;
  }, {});
}

export function rollDie(sides, randomFn = Math.random) {
  return Math.floor(randomFn() * sides) + 1;
}

export function roll4d6Detail(randomFn = Math.random) {
  const dice = Array.from({ length: 4 }, () => rollDie(6, randomFn));
  const minIndex = dice.indexOf(Math.min(...dice));
  const total = dice.reduce((s, d, i) => s + (i === minIndex ? 0 : d), 0);
  return { dice, dropped: minIndex, total };
}

export function buildRolledSets(randomFn = Math.random) {
  return ABILITY_KEYS.map(() => roll4d6Detail(randomFn));
}

export function calcPointBuyCost(values) {
  return ABILITY_KEYS.reduce((sum, key) => sum + (POINT_BUY_COSTS[values[key]] ?? 0), 0);
}

export function pointBuyRemaining(values) {
  return POINT_BUY_BUDGET - calcPointBuyCost(values);
}

export function isFulfilledArrayResult(result) {
  return result?.status === "fulfilled" && Array.isArray(result.value);
}

export function getFulfilledArray(result) {
  return isFulfilledArrayResult(result) ? result.value : [];
}

export const ABILITY_PT_TO_KEY = {
  "força": "str",
  "destreza": "dex",
  "constituição": "con",
  "inteligência": "int",
  "sabedoria": "wis",
  "carisma": "cha",
};

export function getBackgroundAbilityKeys(background) {
  if (!Array.isArray(background?.benefits)) return [];
  const attrLine = background.benefits.find((b) => /^atributos\s*:/i.test(b));
  if (!attrLine) return [];
  const text = attrLine.replace(/^atributos\s*:\s*/i, "");
  return text.split(",").map((s) => ABILITY_PT_TO_KEY[s.trim().toLowerCase()]).filter(Boolean);
}

export function buildBackgroundStats(allowedKeys, mode, plusTwo = null, plusOne = null, plusOnes = []) {
  const stats = { str: 0, dex: 0, con: 0, int: 0, wis: 0, cha: 0 };
  const keysSet = new Set(Array.isArray(allowedKeys) ? allowedKeys : []);

  if (mode === "2-1") {
    if (plusTwo && keysSet.has(plusTwo)) stats[plusTwo] = 2;
    if (plusOne && keysSet.has(plusOne) && plusOne !== plusTwo) stats[plusOne] = 1;
    return stats;
  }

  if (mode === "1-1-1") {
    const selected = Array.isArray(plusOnes)
      ? plusOnes.filter((k) => keysSet.has(k)).slice(0, 3)
      : [];

    // Fixed backgrounds with exactly 3 allowed abilities auto-assign +1/+1/+1.
    const finalKeys = selected.length > 0 ? selected : (keysSet.size <= 3 ? [...keysSet] : []);
    finalKeys.forEach((k) => {
      stats[k] = 1;
    });
  }

  return stats;
}

export function getTotalBonus(state, key) {
  return (state.origin?.stats?.[key] || 0) + (state.backgroundStats?.[key] || 0) + (state.tashaAbilityOverride?.[key] || 0);
}

export function getRaceAbilityBonuses(race) {
  if (!race) return [];
  if (Array.isArray(race.abilityBonuses)) return race.abilityBonuses;
  if (race.name === "Tritão") return [1, 1, 1];
  if (race.name === "Linhagem Customizada") return [2];
  return [2, 1];
}

export function getRaceDisplayName(state) {
  if (state.race?.name === "Linhagem Customizada" && state.customLineage?.lineageName?.trim()) {
    return state.customLineage.lineageName.trim();
  }
  return state.race?.name || "";
}

export function hasSubclasses(charClass) {
  return Boolean(charClass && Array.isArray(charClass.subclasses) && charClass.subclasses.length > 0);
}

export function needsSubclassStep(state) {
  return Boolean(
    state.startingPointData &&
      state.startingPointData.level > 1 &&
      hasSubclasses(state.charClass)
  );
}

export function getActiveStepIds(state) {
  return ALL_STEP_IDS.filter((stepId) => stepId !== "subclasse" || needsSubclassStep(state));
}

export function getStepOrder(stepId) {
  return ALL_STEP_IDS.indexOf(stepId);
}

export function getStepVisual(stepId) {
  return STEP_VISUALS[stepId] || STEP_VISUALS.identidade;
}

export function isStepSelected(stepId, state) {
  switch (stepId) {
    case "identidade": return Boolean(state.name && state.name.trim());
    case "raca": {
      if (!state.race) return false;

      if (state.race.name === "Humano") {
        return Boolean(
          normalizeTextValue(state.humanRaceChoice?.skill) &&
          normalizeTextValue(state.humanRaceChoice?.feat)
        );
      }

      if (state.race.name === "Linhagem Customizada") {
        const feat = normalizeTextValue(state.customLineage?.originFeat);
        const selectedSkill = normalizeTextValue(state.customLineage?.skills?.find(Boolean) || "");
        const hasBenefit = Boolean(state.customLineage?.darkvision || selectedSkill);
        return Boolean(feat && hasBenefit);
      }

      return true;
    }
    case "background": {
      if (!state.background || state.backgroundStatMode === null) return false;

      const bgStats = state.backgroundStats || {};
      const plusTwoCount = ABILITY_KEYS.filter((k) => bgStats[k] === 2).length;
      const plusOneCount = ABILITY_KEYS.filter((k) => bgStats[k] === 1).length;

      if (state.backgroundStatMode === "2-1" && (plusTwoCount !== 1 || plusOneCount !== 1)) {
        return false;
      }

      if (state.backgroundStatMode === "1-1-1" && (plusTwoCount !== 0 || plusOneCount !== 3)) {
        return false;
      }

      if (state.background === "Custom Background") {
        return Boolean(normalizeTextValue(state.customBackground?.originFeat));
      }
      return true;
    }
    case "nivel": return Boolean(state.startingPoint);
    case "classe": return Boolean(state.charClass);
    case "subclasse": return Boolean(state.subclassData);
    case "atributos": return Boolean(state.attrConfirmed);
    default: return false;
  }
}

export function getAttributeBonus(origin, key) {
  return origin?.stats?.[key] || 0;
}

export function getAttributeTotal(state, key) {
  return (state.attributes[key] || 10) + getTotalBonus(state, key);
}

export function getFullName(state, fallback = "Nome do Herói") {
  const fullName = [normalizeTextValue(state.name), normalizeTextValue(state.surname)]
    .filter(Boolean)
    .join(" ");
  return fullName || fallback;
}

export function getBackgroundByName(backgrounds, backgroundName) {
  if (!Array.isArray(backgrounds) || !backgroundName) return null;
  return backgrounds.find((background) => background.name === backgroundName) || null;
}

export function getBackgroundGrantedFeat(background) {
  if (!background) return "";

  const explicitFeat = normalizeTextValue(
    background.feat || background.grantedFeat || background.feature
  );
  if (explicitFeat) return explicitFeat;

  if (!Array.isArray(background.benefits)) return "";

  const derivedFeat = background.benefits.find((benefit) => /^(tra[cç]o|feat)\s*:/i.test(benefit));
  return normalizeTextValue(derivedFeat).replace(/^(tra[cç]o|feat)\s*:\s*/i, "");
}

export function getEffectiveFeat1(state) {
  return normalizeTextValue(state.feat1) || normalizeTextValue(state.backgroundFeat);
}

export function getRaceMandatoryChoicesSummary(state) {
  if (state.race?.name === "Humano") {
    const skill = normalizeTextValue(state.humanRaceChoice?.skill);
    const feat = normalizeTextValue(state.humanRaceChoice?.feat);
    return [
      skill ? `Perícia: ${skill}` : "",
      feat ? `Talento de Origem: ${feat}` : "",
    ].filter(Boolean).join(" · ");
  }

  if (state.race?.name === "Linhagem Customizada") {
    const skill = normalizeTextValue(state.customLineage?.skills?.find(Boolean) || "");
    const benefit = state.customLineage?.darkvision
      ? "Visão no Escuro 60ft"
      : (skill ? `Perícia: ${skill}` : "");
    const feat = normalizeTextValue(state.customLineage?.originFeat);

    return [
      benefit,
      feat ? `Talento de Origem: ${feat}` : "",
    ].filter(Boolean).join(" · ");
  }

  return "";
}

export function getCustomBackgroundOriginFeat(state) {
  if (state.background !== "Custom Background") return "";
  return normalizeTextValue(state.customBackground?.originFeat);
}

export function getRaceOriginFeat(state) {
  if (state.race?.name === "Humano") {
    return normalizeTextValue(state.humanRaceChoice?.feat);
  }

  if (state.race?.name === "Linhagem Customizada") {
    return normalizeTextValue(state.customLineage?.originFeat);
  }

  return "";
}

export function getPreviewLetter(state) {
  const name = normalizeTextValue(state.name);
  return name ? name[0].toUpperCase() : "?";
}

export function getSubtitle(state) {
  const raceName = getRaceDisplayName(state);
  return [raceName, state.charClass?.name, state.subclassData?.name]
    .filter(Boolean)
    .join(" · ");
}

export function hasHomebrewContent(state) {
  return Boolean((state.race && state.race.homebrew) || (state.charClass && state.charClass.homebrew));
}

export function getPreviewBadges(state) {
  const badges = [];

  if (state.startingPointData) {
    badges.push({
      key: "level",
      className: "",
      label: `Nv ${state.startingPointData.level} · ${state.startingPointData.name}`,
    });
  }
  if (state.background) {
    badges.push({ key: "background", className: "", label: state.background });
  }
  if (state.subclassData) {
    badges.push({ key: "subclass", className: "secret", label: `✶ ${state.subclassData.name}` });
  }
  if (hasHomebrewContent(state)) {
    badges.push({ key: "homebrew", className: "homebrew", label: "Homebrew" });
  }

  return badges;
}

export const HP_FIXED_PER_LEVEL = { 6: 4, 8: 5, 10: 6, 12: 7 };

export function getHpFixedPerLevel(hitDie) {
  return HP_FIXED_PER_LEVEL[hitDie] ?? Math.floor(hitDie / 2) + 1;
}

export function calculateHP(state) {
  if (!state.charClass || !state.startingPointData) {
    return 0;
  }

  const hitDie = state.charClass.hit_die || 8;
  const conTotal = getAttributeTotal(state, "con");
  const conModifier = mod(conTotal);
  const level = state.startingPointData.level;
  const diceNeeded = level - 1;

  // Nível 1 é sempre fixo: máximo do dado + mod CON
  if (level === 1) {
    return hitDie + conModifier;
  }

  // Níveis 3/5: verificar se há dados rolados
  if (
    state.hpMethodLocked === "roll" &&
    Array.isArray(state.hpRolledValues) &&
    state.hpRolledValues.length === diceNeeded
  ) {
    const rolledSum = state.hpRolledValues.reduce((a, b) => a + b, 0);
    return hitDie + rolledSum + conModifier * level;
  }

  // Método fixo (padrão)
  const fixedPerLevel = getHpFixedPerLevel(hitDie);
  return hitDie + fixedPerLevel * diceNeeded + conModifier * level;
}

export function getCharacterLevel(state) {
  return state.startingPointData ? state.startingPointData.level : 1;
}

export function getExportProficiencyBonus(state) {
  return state.startingPointData ? state.startingPointData.proficiencyBonus : 2;
}

export function getSummaryRows(state) {
  const effectiveFeat1 = getEffectiveFeat1(state);
  const hasFeatInput = Boolean(state.startingPointData?.extraFields?.includes("feat1"));
  const raceMandatorySummary = getRaceMandatoryChoicesSummary(state);
  const raceOriginFeat = getRaceOriginFeat(state);
  const customBackgroundOriginFeat = getCustomBackgroundOriginFeat(state);
  const rows = [
    ["Nome", getFullName(state, "—")],
    ["Background", state.background || "—"],
    ["Raça", state.race ? getRaceDisplayName(state) + (state.race.homebrew ? " (HB)" : "") : "—"],
    [
      "Classe",
      state.charClass
        ? state.charClass.name + (state.charClass.homebrew ? " (HB)" : "") + ` (d${state.charClass.hit_die})`
        : "—",
    ],
    [
      "Subclasse",
      state.subclassData
        ? state.subclassData.name
        : state.startingPointData && state.startingPointData.level > 1
          ? "— (não selecionada)"
          : "—",
    ],
    [
      "Nível Inicial",
      state.startingPointData
        ? `${state.startingPointData.level} — ${state.startingPointData.name}`
        : "—",
    ],
    ["HP", state.charClass && state.startingPointData ? calculateHP(state) : "—"],
    [
      "Proficiency",
      state.startingPointData ? `+${state.startingPointData.proficiencyBonus}` : "—",
    ],
  ];

  const attributesLabel = ABILITY_KEYS.map((key) => `${key.toUpperCase()}: ${getAttributeTotal(state, key)}`).join(" · ");
  rows.push(["Atributos", attributesLabel]);

  if (raceMandatorySummary) {
    rows.push(["Escolhas Raciais", raceMandatorySummary]);
  }

  if (raceOriginFeat) {
    rows.push(["Talento de Origem (Raça)", raceOriginFeat]);
  }

  if (customBackgroundOriginFeat) {
    rows.push(["Talento de Origem (Background)", customBackgroundOriginFeat]);
  }

  if (effectiveFeat1 && !hasFeatInput) {
    rows.push(["Feat do Background", effectiveFeat1]);
  }

  return rows;
}

export function getExtraFields(state) {
  const fields = state.startingPointData?.extraFields || [];
  const effectiveFeat1 = getEffectiveFeat1(state);
  const backgroundFeatActive = Boolean(state.backgroundFeat) && effectiveFeat1 === normalizeTextValue(state.backgroundFeat);

  return fields.map((field) => ({
    field,
    label:
      field === "feat1" && backgroundFeatActive
        ? "Feat do Background"
        : EXTRA_FIELD_LABELS[field] || field,
    value: field === "feat1" ? effectiveFeat1 : state[field] || "",
    helperText:
      field === "feat1" && backgroundFeatActive
        ? "Preenchido automaticamente a partir do background selecionado."
        : "",
  }));
}

export function escapeHtml(value) {
  return String(value)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#39;");
}

export function buildFoundryJSON(state) {
  const level = getCharacterLevel(state);
  const hp = calculateHP(state);
  const prof = getExportProficiencyBonus(state);

  const abilities = {};
  ABILITY_KEYS.forEach((key) => {
    abilities[key] = { value: getAttributeTotal(state, key) };
  });

  return {
    name: getFullName(state, ""),
    type: "character",
    system: {
      abilities,
      details: {
        race: getRaceDisplayName(state),
        background: state.background === "Custom Background" ? "Custom Background (2024)" : (state.background || ""),
        level,
        biography: { value: state.biography || "" },
      },
      attributes: {
        hp: { value: hp, max: hp },
        ac: { value: 10 },
        prof,
      },
    },
    items: state.charClass
      ? [
          {
            name: state.charClass.name,
            type: "class",
            system: { levels: level },
          },
        ]
      : [],
    flags: {
      worldhub: {
        startingPoint: level,
        startingPointName: state.startingPointData ? state.startingPointData.name : "",
        subclass: state.subclass,
        profileImageName: state.profileImageName || "",
        profileImageCropped: state.profileImageCropped || "",
        profileImageOriginal: state.profileImageOriginal || "",
        profileCropX: Number.isFinite(state.profileCropX) ? state.profileCropX : 50,
        profileCropY: Number.isFinite(state.profileCropY) ? state.profileCropY : 50,
        profileCropZoom: Number.isFinite(state.profileCropZoom) ? state.profileCropZoom : 1,
        origin: state.origin ? state.origin.name : null,
        originRegion: state.origin ? state.origin.region : null,
        originBonuses: state.origin ? state.origin.bonuses : [],
        homebrew: hasHomebrewContent(state),
        createdAt: new Date().toISOString(),
        tashaAbilityOverride: state.tashaAbilityOverride || { str: 0, dex: 0, con: 0, int: 0, wis: 0, cha: 0 },
        ...(state.race?.name === "Humano" ? {
          humanRaceChoice: {
            skill: normalizeTextValue(state.humanRaceChoice?.skill),
            originFeat: normalizeTextValue(state.humanRaceChoice?.feat),
          },
        } : {}),
        ...(state.race?.name === "Linhagem Customizada" && state.customLineage ? {
          customLineage: {
            lineageName: state.customLineage.lineageName || "",
            abilityBonus: Object.fromEntries(
              ABILITY_KEYS.filter(k => (state.tashaAbilityOverride?.[k] || 0) > 0)
                .map(k => [k, state.tashaAbilityOverride[k]])
            ),
            originFeat: state.customLineage.originFeat || "",
            skills: state.customLineage.skills || [],
            darkvision: Boolean(state.customLineage.darkvision),
            size: state.customLineage.size || "Medium",
          },
        } : {}),
        ...(state.background === "Custom Background" && state.customBackground ? {
          customBackground: {
            skills: state.customBackground.skills || [],
            tool: state.customBackground.tool || "",
            originFeat: state.customBackground.originFeat || "",
            equipment: "50 GP",
            equipmentNotes: state.customBackground.equipmentNotes || "",
          },
        } : {}),
      },
    },
  };
}

export function buildTextExport(state) {
  const fullName = getFullName(state, "");
  const level = getCharacterLevel(state);
  const hp = calculateHP(state);
  const prof = getExportProficiencyBonus(state);
  const effectiveFeat1 = getEffectiveFeat1(state);
  const raceMandatorySummary = getRaceMandatoryChoicesSummary(state);
  const customBackgroundOriginFeat = getCustomBackgroundOriginFeat(state);

  let text = "═══════════════════════════════════════\n";
  text += "  FICHA DE PERSONAGEM — WORLD HUB RPG\n";
  text += "═══════════════════════════════════════\n\n";
  text += `Nome: ${fullName}\n`;
  text += `Background: ${state.background === "Custom Background" ? "Custom Background (2024)" : (state.background || "—")}\n`;
  text += `Raça: ${getRaceDisplayName(state) || "—"}\n`;
  text += `Origem: ${state.origin ? state.origin.name + " (" + state.origin.region + ")" : "Nenhuma"}\n`;
  text += `Classe: ${state.charClass ? state.charClass.name + " (d" + state.charClass.hit_die + ")" : "—"}\n`;
  text += `Nível: ${level} — ${state.startingPointData ? state.startingPointData.name : "—"}\n`;
  text += `Alinhamento: ${state.alignment || "—"}\n\n`;
  text += "── ATRIBUTOS ──\n";
  ABILITY_KEYS.forEach((key) => {
    const total = getAttributeTotal(state, key);
    text += `  ${key.toUpperCase()}: ${total} (${modStr(total)})\n`;
  });
  text += "\n── COMBATE ──\n";
  text += `  HP: ${hp}\n`;
  text += `  Proficiency Bonus: +${prof}\n`;
  if (state.profileImageCropped || state.profileImageOriginal) {
    text += "  Retratos: incluídos na versão em PDF\n";
  }
  if (raceMandatorySummary) text += `  Escolhas Raciais: ${raceMandatorySummary}\n`;
  if (customBackgroundOriginFeat) text += `  Talento de Origem (Background): ${customBackgroundOriginFeat}\n`;
  if (state.subclass) text += `  Subclasse: ${state.subclass}\n`;
  if (effectiveFeat1) text += `  Feat: ${effectiveFeat1}\n`;
  if (state.feat2) text += `  Feat: ${state.feat2}\n`;
  if (state.asi) text += `  ASI: ${state.asi}\n`;
  if (state.biography) {
    text += `\n── HISTÓRIA ──\n  ${state.biography}\n`;
  }
  if (state.origin) {
    text += "\n── BÔNUS DE ORIGEM ──\n";
    state.origin.bonuses.forEach((bonus) => {
      text += `  • ${bonus}\n`;
    });
  }
  const tashaKeys = ABILITY_KEYS.filter(k => (state.tashaAbilityOverride?.[k] || 0) > 0);
  if (tashaKeys.length > 0) {
    text += "\n── BÔNUS RACIAIS (TASHA’S) ──\n";
    tashaKeys.forEach(k => {
      text += `  ${k.toUpperCase()}: +${state.tashaAbilityOverride[k]}\n`;
    });
  }
  if (state.race?.name === "Linhagem Customizada" && state.customLineage) {
    text += "\n── CUSTOM LINEAGE ──\n";
    text += `  Linhagem: ${state.customLineage.lineageName || "—"}\n`;
    if (state.customLineage.originFeat) text += `  Talento de Origem: ${state.customLineage.originFeat}\n`;
    if (state.customLineage.skills?.filter(Boolean).length) text += `  Perícias: ${state.customLineage.skills.filter(Boolean).join(", ")}\n`;
    text += `  Darkvision: ${state.customLineage.darkvision ? "Sim" : "Não"}\n`;
    text += `  Tamanho: ${state.customLineage.size || "Medium"}\n`;
  }
  if (state.background === "Custom Background" && state.customBackground) {
    text += "\n── CUSTOM BACKGROUND (2024) ──\n";
    if (state.customBackground.skills?.filter(Boolean).length) text += `  Perícias: ${state.customBackground.skills.filter(Boolean).join(", ")}\n`;
    if (state.customBackground.tool) text += `  Ferramenta: ${state.customBackground.tool}\n`;
    if (state.customBackground.originFeat) text += `  Talento de Origem: ${state.customBackground.originFeat}\n`;
    text += "  Equipamento: 50 GP\n";
    if (state.customBackground.equipmentNotes) text += `  Notas: ${state.customBackground.equipmentNotes}\n`;
  }
  text += "\n═══════════════════════════════════════\n";
  return text;
}

export function buildPdfHtml(state) {
  const fullName = getFullName(state, "");
  const level = getCharacterLevel(state);
  const hp = calculateHP(state);
  const prof = getExportProficiencyBonus(state);
  const effectiveFeat1 = getEffectiveFeat1(state);
  const raceMandatorySummary = getRaceMandatoryChoicesSummary(state);
  const customBackgroundOriginFeat = getCustomBackgroundOriginFeat(state);
  const croppedImage = normalizeTextValue(state.profileImageCropped);
  const originalImage = normalizeTextValue(state.profileImageOriginal);
  const hasAnyPortrait = Boolean(croppedImage || originalImage);
  const croppedPortraitSrc = escapeHtml(croppedImage || originalImage);
  const originalPortraitSrc = escapeHtml(originalImage || croppedImage);
  const attributeRows = ABILITY_KEYS.map((key) => {
    const total = getAttributeTotal(state, key);
    return `<tr><td>${key.toUpperCase()}</td><td>${total}</td><td>${modStr(total)}</td></tr>`;
  }).join("");

  return `<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Ficha — ${escapeHtml(fullName)}</title>
<style>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=EB+Garamond:wght@400;500;600&display=swap');
*{margin:0;padding:0;box-sizing:border-box}
body{font-family:'EB Garamond',serif;color:#1a1a1a;padding:2rem;max-width:800px;margin:0 auto}
h1{font-family:'Cinzel',serif;font-size:2rem;border-bottom:2px solid #c9a84c;padding-bottom:0.3rem;margin-bottom:1rem}
h2{font-family:'Cinzel',serif;font-size:1.2rem;color:#2a4a6a;margin:1.2rem 0 0.4rem;border-bottom:1px solid #ddd;padding-bottom:0.2rem}
.meta{display:grid;grid-template-columns:1fr 1fr;gap:0.3rem 1rem;margin-bottom:1rem}
.meta span{font-weight:600}
table{width:100%;border-collapse:collapse;margin-bottom:1rem}
td,th{padding:0.35rem 0.6rem;border:1px solid #ddd;text-align:center}
th{background:#f5f0e4;font-family:'Cinzel',serif;font-size:0.85rem}
.notes{border:1px dashed #ccc;padding:0.8rem;min-height:80px;margin-top:0.3rem;font-style:italic;color:#666}
.badge{display:inline-block;padding:0.1rem 0.5rem;border:1px solid #c9a84c;border-radius:999px;font-size:0.82rem;margin-right:0.3rem}
.portrait-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:0.8rem;margin-bottom:1rem}
.portrait-card{border:1px solid #ddd;border-radius:10px;background:#faf7f0;padding:0.6rem}
.portrait-card h3{font-family:'Cinzel',serif;font-size:0.82rem;margin-bottom:0.45rem;color:#2a4a6a}
.portrait-card img{display:block;width:100%;max-height:260px;object-fit:contain;background:#0f1726;border-radius:8px}
.portrait-card--cropped img{aspect-ratio:1/1;object-fit:cover;border-radius:999px;max-width:220px;margin:0 auto;border:2px solid #c9a84c;background:#0f1726}
@media print{body{padding:1rem}}
</style></head><body>
<h1>${escapeHtml(fullName)}</h1>
<div class="meta">
  <div>Raça: <span>${escapeHtml(getRaceDisplayName(state) || "—")}</span></div>
  <div>Classe: <span>${state.charClass ? escapeHtml(state.charClass.name) : "—"}</span></div>
  <div>Background: <span>${state.background === "Custom Background" ? "Custom Background (2024)" : escapeHtml(state.background || "—")}</span></div>
  <div>Nível: <span>${level} — ${state.startingPointData ? escapeHtml(state.startingPointData.name) : "—"}</span></div>
  <div>Origem: <span>${state.origin ? escapeHtml(state.origin.name) : "Nenhuma"}</span></div>
  <div>HP: <span>${hp}</span></div>
  <div>Proficiency: <span>+${prof}</span></div>
</div>
${state.race && state.race.homebrew ? '<span class="badge">Homebrew Race</span>' : ""}
${state.charClass && state.charClass.homebrew ? '<span class="badge">Homebrew Class</span>' : ""}
${raceMandatorySummary ? `<p><strong>Escolhas Raciais:</strong> ${escapeHtml(raceMandatorySummary)}</p>` : ""}
${customBackgroundOriginFeat ? `<p><strong>Talento de Origem (Background):</strong> ${escapeHtml(customBackgroundOriginFeat)}</p>` : ""}
${hasAnyPortrait ? `<h2>Retratos do Herói</h2>
<div class="portrait-grid">
  <div class="portrait-card portrait-card--cropped">
    <h3>Foto de Perfil (Recortada)</h3>
    <img src="${croppedPortraitSrc}" alt="Foto de perfil recortada" />
  </div>
  <div class="portrait-card">
    <h3>Foto Original (Inteira)</h3>
    <img src="${originalPortraitSrc}" alt="Foto original inteira" />
  </div>
</div>` : ""}
<h2>Atributos</h2>
<table><tr><th>Atributo</th><th>Valor</th><th>Modificador</th></tr>${attributeRows}</table>
${state.origin ? `<h2>Bônus de Origem</h2><p>${state.origin.bonuses.map((bonus) => escapeHtml(bonus)).join(" · ")}</p>` : ""}
${(() => { const tk = ABILITY_KEYS.filter(k => (state.tashaAbilityOverride?.[k] || 0) > 0); return tk.length > 0 ? `<h2>Bônus Raciais (Tasha’s)</h2><p>${tk.map(k => `${k.toUpperCase()}: +${state.tashaAbilityOverride[k]}`).join(" · ")}</p>` : ""; })()}
${state.race?.name === "Linhagem Customizada" && state.customLineage ? `<h2>Custom Lineage</h2><p>Linhagem: ${escapeHtml(state.customLineage.lineageName || "—")}</p>${state.customLineage.originFeat ? `<p>Talento de Origem: ${escapeHtml(state.customLineage.originFeat)}</p>` : ""}${state.customLineage.skills?.filter(Boolean).length ? `<p>Perícias: ${state.customLineage.skills.filter(Boolean).map(s => escapeHtml(s)).join(", ")}</p>` : ""}<p>Darkvision: ${state.customLineage.darkvision ? "Sim" : "Não"} · Tamanho: ${escapeHtml(state.customLineage.size || "Medium")}</p>` : ""}
${state.background === "Custom Background" && state.customBackground ? `<h2>Custom Background (2024)</h2>${state.customBackground.skills?.filter(Boolean).length ? `<p>Perícias: ${state.customBackground.skills.filter(Boolean).map(s => escapeHtml(s)).join(", ")}</p>` : ""}${state.customBackground.tool ? `<p>Ferramenta: ${escapeHtml(state.customBackground.tool)}</p>` : ""}${state.customBackground.originFeat ? `<p>Talento de Origem: ${escapeHtml(state.customBackground.originFeat)}</p>` : ""}<p>Equipamento: 50 GP${state.customBackground.equipmentNotes ? ` — ${escapeHtml(state.customBackground.equipmentNotes)}` : ""}</p>` : ""}
${state.startingPointData && state.startingPointData.features.length ? `<h2>Features (Nível ${level})</h2><ul>${state.startingPointData.features.map((feature) => `<li>${escapeHtml(feature)}</li>`).join("")}</ul>` : ""}
${state.subclass ? `<p><strong>Subclasse:</strong> ${escapeHtml(state.subclass)}</p>` : ""}
${effectiveFeat1 ? `<p><strong>Feat:</strong> ${escapeHtml(effectiveFeat1)}</p>` : ""}
${state.feat2 ? `<p><strong>Feat:</strong> ${escapeHtml(state.feat2)}</p>` : ""}
${state.asi ? `<p><strong>ASI:</strong> ${escapeHtml(state.asi)}</p>` : ""}
<h2>História</h2>
<div class="notes">${state.biography ? escapeHtml(state.biography) : "(escreva a história do personagem aqui)"}</div>
<h2>Notas</h2>
<div class="notes"></div>
</body></html>`;
}

export function createStateSnapshot(state) {
  if (typeof structuredClone === "function") {
    return structuredClone(state);
  }
  return JSON.parse(JSON.stringify(state));
}

export function getExportFileBaseName(state) {
  return normalizeTextValue(state.name) || "personagem";
}

function hashString(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function slugify(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
}

function getEntityName(entity) {
  if (typeof entity === "string") return entity;
  if (entity && typeof entity.name === "string") return entity.name;
  return "world-hub";
}

function normalizeForMatch(value) {
  return slugify(value).replace(/-/g, " ");
}

export function buildCardFallbackImage(label, accent = "#2a4a6a") {
  const safeLabel = escapeHtml(label || "World Hub RPG");
  const svg = `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 640 360'>
    <defs>
      <linearGradient id='bg' x1='0' y1='0' x2='1' y2='1'>
        <stop offset='0%' stop-color='#0d1420'/>
        <stop offset='100%' stop-color='${accent}'/>
      </linearGradient>
      <radialGradient id='glow' cx='20%' cy='20%' r='60%'>
        <stop offset='0%' stop-color='rgba(255,255,255,0.22)'/>
        <stop offset='100%' stop-color='rgba(255,255,255,0)'/>
      </radialGradient>
    </defs>
    <rect width='640' height='360' fill='url(#bg)'/>
    <rect width='640' height='360' fill='url(#glow)'/>
    <g opacity='0.18' fill='none' stroke='rgba(255,255,255,0.35)'>
      <path d='M0 240 C140 180, 240 330, 360 250 C470 180, 560 280, 640 230'/>
      <path d='M0 280 C120 240, 250 350, 390 290 C500 240, 580 320, 640 300'/>
    </g>
    <text x='36' y='320' font-family='Cinzel, serif' font-size='28' fill='rgba(255,255,255,0.9)'>${safeLabel}</text>
  </svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

const LOCAL_CARD_BASE = "assets/images/cards/";
const LOCAL_DEFAULT_IMAGE = `${LOCAL_CARD_BASE}default-fantasy.svg`;

const LOCAL_CARD_RULES = {
  raca: [
    { test: /anao|forjado|pedra/, image: "race-mountains.svg" },
    { test: /elf|gnomo/, image: "race-forest.svg" },
    { test: /humano|halfling/, image: "race-city.svg" },
    { test: /tiefling/, image: "race-infernal.svg" },
    { test: /draconato|cinzeiro|orc/, image: "race-volcanic.svg" },
    { test: /marefero|mare|costa/, image: "race-ocean.svg" },
  ],
  classe: [
    { test: /barbaro|guerreiro|paladino|patrulheiro|pugilista/, image: "class-martial.svg" },
    { test: /mago|feiticeiro|bardo|cronista/, image: "class-arcane.svg" },
    { test: /clerigo/, image: "class-divine.svg" },
    { test: /druida|monge/, image: "class-primal.svg" },
    { test: /ladino|bruxo/, image: "class-shadow.svg" },
  ],
  subclasse: [
    { test: /tempo|futuro|passado|cron/, image: "class-time.svg" },
    { test: /sombras|assassino|ladrao|trapaceiro/, image: "class-shadow.svg" },
    { test: /juramento|dominio|vida|luz|guerra|devo|antigos|vinganca/, image: "class-divine.svg" },
    { test: /totem|terra|lua|bestas|elementos|mao aberta|mares|cinzeiro/, image: "class-primal.svg" },
    { test: /berserker|campeao|batalha|cavaleiro/, image: "class-martial.svg" },
    { test: /evocacao|abjuracao|ilusao|necromancia|transmutacao|adivinhacao|draconica|selvagem|arcano/, image: "class-arcane.svg" },
  ],
  origem: [
    { test: /norte|glacial/, image: "origin-north.svg" },
    { test: /costa|mares|leste/, image: "origin-coast.svg" },
    { test: /floramaris|floresta|sul/, image: "origin-forest.svg" },
    { test: /deserto|casandrael|oeste/, image: "origin-desert.svg" },
    { test: /capital|imperial|auros|centro/, image: "origin-capital.svg" },
  ],
};

function resolveLevelImage(entity) {
  if (entity && typeof entity === "object") {
    if (entity.level === 1) return `${LOCAL_CARD_BASE}level-1.svg`;
    if (entity.level === 3) return `${LOCAL_CARD_BASE}level-3.svg`;
    if (entity.level === 5) return `${LOCAL_CARD_BASE}level-5.svg`;
  }
  return `${LOCAL_CARD_BASE}level-1.svg`;
}

function resolveRuleBasedImage(stepId, selectionName) {
  const rules = LOCAL_CARD_RULES[stepId] || [];
  const name = normalizeForMatch(selectionName);
  const match = rules.find((rule) => rule.test.test(name));
  if (!match) return null;
  return `${LOCAL_CARD_BASE}${match.image}`;
}

function resolveLocalCardImage(stepId, entity) {
  const name = getEntityName(entity);
  if (stepId === "nivel") return resolveLevelImage(entity);

  const resolved = resolveRuleBasedImage(stepId, name);
  return resolved || LOCAL_DEFAULT_IMAGE;
}

function getCustomTheme(entity) {
  if (!entity || typeof entity !== "object") return null;
  if (!entity.theme || typeof entity.theme !== "object") return null;
  return entity.theme;
}

export function getCardImage(stepId, entity, options = {}) {
  const customTheme = getCustomTheme(entity);
  if (customTheme && typeof customTheme.image === "string" && customTheme.image.trim()) {
    return customTheme.image;
  }

  const name = getEntityName(entity);
  if (entity && typeof entity === "object" && typeof entity.image === "string" && entity.image.trim()) {
    return entity.image;
  }

  const localImage = resolveLocalCardImage(stepId, entity);
  if (localImage) return localImage;

  const fallbackPalette = getThemePalette(`${stepId}-${name}`);
  return buildCardFallbackImage(name, fallbackPalette.accent);
}

export function getThemePalette(seedText) {
  const hue = hashString(seedText) % 360;
  const accent = `hsl(${hue} 72% 62%)`;
  const soft = `hsla(${hue} 72% 60% / 0.25)`;
  const glow = `hsla(${hue} 90% 65% / 0.32)`;
  return { accent, soft, glow };
}

export function getStepSelection(stepId, state) {
  if (stepId === "raca") return state.race;
  if (stepId === "nivel") return state.startingPointData;
  if (stepId === "classe") return state.charClass;
  if (stepId === "subclasse") return state.subclassData;
  return null;
}

export function getStepTheme(stepId, state) {
  const selection = getStepSelection(stepId, state);
  if (!selection) return null;

  const name = getEntityName(selection);
  const palette = getThemePalette(`${stepId}-${name}`);
  const customTheme = getCustomTheme(selection) || {};
  const imageUrl =
    typeof customTheme.image === "string" && customTheme.image.trim()
      ? customTheme.image
      : getCardImage(stepId, selection, { width: 1400, height: 900 });

  return {
    name,
    imageUrl,
    accent: customTheme.accent || palette.accent,
    soft: customTheme.soft || palette.soft,
    glow: customTheme.glow || palette.glow,
  };
}
